import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from 'src/app/app.component';
import { CrudHttp } from 'src/app/helpers/CrudHttp';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { BloqueConfiguracion, Pregunta } from 'src/app/types/type';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
declare var $: any;

@Component({
  selector: 'app-checklist-paso3',
  templateUrl: './checklist-paso3.component.html',
  styleUrls: ['./checklist-paso3.component.css']
})
export class ChecklistPaso3Component implements OnInit {
  idChecklist: number;
  idTipoRevision: number;
  title: string;
  item: object;
  rubros: any;
  bloques: BloqueConfiguracion[];
  bloqueEdit: any;
  subMenus: { active: boolean; child: boolean; label: string; router: string; class: string; }[];
  crudRubro: CrudHttp;
  preguntaEdit: Pregunta;
  crudPregunta: any;
  totalPonderaciones = 0;

  constructor(private configService: ConfiguracionService, private activatedRoute: ActivatedRoute, private http: HttpClient, private router: Router, private father: AppComponent) {
    father.moduleName = 'Configuracion';
    this.idChecklist = parseInt(this.activatedRoute.snapshot.params.id);
    this.idTipoRevision = parseInt(this.activatedRoute.snapshot.params.idrevision);

    this.title = 'Checklist paso 3'

    this.crudRubro = new CrudHttp(http);
    this.crudRubro.methodGet = 'GetRubrosChecklist?idChecklist=' + this.idChecklist;

    this.crudPregunta = new CrudHttp(http);
    this.crudPregunta.methodGet = 'Getreguntas';
    this.crudPregunta.methodPost = 'SetPregunta';
    this.crudPregunta.methodPut = 'UpdatePregunta';
    this.crudPregunta.methodDelete = 'DeletePregunta';

    this.bloqueEdit = {
      Nombre: '',
      Ponderacion: 100,
      Orden: 1
    };
  }

  ngOnInit() {
    this.loadSubMenu();
    this.configService.getRubrosChecklist(this.idChecklist)
      .subscribe(resp => {
        if (resp.Result.Exito)
          this.bloques = resp.Result.Data as BloqueConfiguracion[];
        else
          Utilerias.alertClient('', resp.Result.Error, 1);

        this.validBtnContinue()
      });
    $("#modalNewPregunta").on('hidden.bs.modal', function () {
      Utilerias.ClearFields('#DescripcionNewPregunta');
      Utilerias.ClearFields('#OrdenNewPregunta');
      $('#cbNew').prop('checked', false);
    });
  }

  newPreguntaClick(id: number, preguntas: Pregunta[]) {
    this.totalPonderaciones = this.sumaPonderaciones(preguntas);
    this.preguntaEdit = undefined;
    localStorage.removeItem('IdRubroNewPregunta');
    localStorage.removeItem('IdPreguntaEdit');
    localStorage.IdRubroNewPregunta = id;
    $('#modalNewPregunta').modal('show');
  }

  editPreguntaClick(item: Pregunta, ponderacion: number, preguntas: Pregunta[]) {
    this.totalPonderaciones = this.sumaPonderaciones(preguntas) - ponderacion;
    this.preguntaEdit = item;
    localStorage.IdPreguntaEdit = item.IdPregunta;
    $('#modalNewPregunta').modal('show');
  }

  deletePreguntaClick(idRubro, id) {
    Utilerias.alertConfirm('¿Deseas eliminar la pregunta?')
      .then(res => {
        if (res.value) {
          this.crudPregunta.delete({ idPregunta: id })
            .then(() => {
              let flag = false;
              for (let bloque of this.bloques) {
                for (let rubro of bloque.Rubros) {
                  if (flag = rubro.IdRubro == idRubro) {

                    let aux = rubro.Preguntas;
                    aux = aux.filter(x => x.IdPregunta != id);
                    rubro.Preguntas = aux;
                    break;
                  }
                }
                if (flag) { break; }
              }
              Utilerias.showLoader(false);
            });
        }
      })
  }

  saveEditQuestion(question: Pregunta) {
    let flag = false;
    if (localStorage?.IdPreguntaEdit !== undefined) {
      for (let bloque of this.bloques) {
        for (let rubro of bloque.Rubros) {
          if (rubro.IdRubro == question.IdRubro) {
            for (let pregunta of rubro.Preguntas) {
              if (flag = pregunta.IdPregunta == question.IdPregunta) {
                pregunta.Descripcion = question.Descripcion;
                pregunta.Orden = question.Orden;
                pregunta.FlagComentario = question.FlagComentario;
                pregunta.FlagEvidencia = question.FlagEvidencia;
                pregunta.Ponderacion = question.Ponderacion;
                this.preguntaEdit = undefined;
                break;
              }
            }
            if (flag) { break; }
          }
        }
        if (flag) { break; }
      }
    } else {
      for (let bloque of this.bloques) {
        for (let rubro of bloque.Rubros) {
          if (flag = rubro.IdRubro == question.IdRubro) {
            rubro.Preguntas.push(question);
            break;
          }
        }
        if (flag) { break; }
      }
    }
    this.totalPonderaciones = 0
    localStorage.removeItem('IdRubroNewPregunta');
    localStorage.removeItem('IdPreguntaEdit');
    $('#modalNewPregunta').modal('hide');
  }

  reqEvidenciaClick(item) {
    item.FlagEvidencia = item.FlagEvidencia ? 0 : 1;
    let obj = {
      p: item
    };
    this.crudPregunta.put(obj)
      .then(() => {
        Utilerias.showLoader(false)
      });
  }

  reqComentarioClick(event, pregunta) {
    const inpunt = event.target as HTMLInputElement;
    if (inpunt.checked)
      pregunta = { ...pregunta, FlagComentario: true }
    else
      pregunta = { ...pregunta, FlagComentario: false }

    let obj = {
      p: pregunta
    }
    this.crudPregunta.put(obj)
      .then(() => {
        Utilerias.showLoader(false);
      });
  }

  loadSubMenu() {
    var items = [
      {
        active: false,
        child: true,
        label: 'Paso 1',
        router: `../../../ChecklistPaso1/${this.idChecklist}/${this.idTipoRevision}`,
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: false,
        child: true,
        label: 'Paso 2',
        router: `../../../ChecklistPaso2/${this.idChecklist}/${this.idTipoRevision}`,
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: true,
        child: false,
        label: 'Paso 3',
        router: null,
        class: 'submenu__item submenu--active d-flex align-items-center'
      }];
    this.subMenus = items;
  }

  validBtnContinue() {
    let totalPonderaciones = 0;
    let totalRubros = 0;
    for (let bloque of this.bloques) {
      for (let rubro of bloque.Rubros) {
        totalRubros++;
        totalPonderaciones += this.sumaPonderaciones(rubro.Preguntas)
      }
    }
    if (totalPonderaciones === 0) return false;
    const reciduo = (totalPonderaciones / totalRubros) % 100 === 0
    return reciduo;
  }

  sumaPonderaciones(preguntas: Pregunta[]) {
    return preguntas.reduce((previous, current) => {
      return previous + current.Ponderacion
    }, 0)
  }
}
